<template>
  <div id="app">
    <home msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
import home from "./components/home.vue";
import DevicePixelRatio from "./assets/js/rem";
export default {
  name: "App",
  components: {
    home,
  },
  created() {
    new DevicePixelRatio().init();
  },
};
</script>

<style>
@import "./assets/css/pc端初始化代码.css";
html,
body,
#app {
  height: 100%;
  /* overflow: auto; */
}
</style>
